import { render, staticRenderFns } from "./InfinityChallengeBox.vue?vue&type=template&id=602e0d5d&scoped=true&"
import script from "./InfinityChallengeBox.vue?vue&type=script&lang=js&"
export * from "./InfinityChallengeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602e0d5d",
  null
  
)

export default component.exports